module.exports = __webpack_public_path__ + "static/media/linkedin.24cf7958.svg";